import PropTypes from "prop-types"

export class FileModel {
  constructor(fileLike) {
    this.id = fileLike.strapiId || fileLike.id
    this.files = fileLike.files || []
    this.fileName = fileLike.fileName || fileLike.name
    this.fileDescription = fileLike.fileDescription || fileLike.description

    this.additionalLinks = fileLike.additionalLinks || []

    let file = {
      size: 0,
      extension: "",
    }
    if (
      this.files &&
      this.files[0] &&
      this.files[0].file &&
      this.files[0].file.localFile
    ) {
      file = this.files[0].file.localFile
    }

    this.fileSize = fileLike.fileSize || file.size
    this.fileType = fileLike.fileType || file.extension
  }

  static fromStrapi(strapiFileModel) {
    return new FileModel({
      ...strapiFileModel,
      files: (strapiFileModel.pdf_file_items || []).filter(
        (file) => !!file.file,
      ),
    })
  }

  static shape = {
    files: PropTypes.array.isRequired,
    additionalLinks: PropTypes.array,
    fileName: PropTypes.object.isRequired,
    fileDescription: PropTypes.object,
    fileType: PropTypes.string.isRequired,
    fileSize: PropTypes.number.isRequired,
  }
}
